"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionPreview = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AdaptableContext_1 = require("../../View/AdaptableContext");
const ExpressionPreview = (props) => {
    var _a;
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const displayColumnFriendlyNames = (_a = adaptable.api.optionsApi.getExpressionOptions()) === null || _a === void 0 ? void 0 : _a.displayColumnFriendlyNamesForExpressions;
    if (!displayColumnFriendlyNames) {
        return React.createElement(React.Fragment, null, adaptable.api.expressionApi.getAdaptableQueryExpression(props.query));
    }
    const expressionWithFriendlyNames = adaptable.api.expressionApi.getAdaptableQueryExpressionWithColumnFriendlyNames(props.query);
    // '[Column Name] > 2' => ['[Column Name]', '>', '2']
    // not the prettiest
    const strWithMarkedGroupes = expressionWithFriendlyNames.replace(/\]/gi, '],').split(',');
    return (React.createElement(React.Fragment, null, strWithMarkedGroupes.map((part, index) => {
        const partEl = part.includes('[') ? React.createElement("i", null, part.replace(/[\[\]]/g, '')) : part;
        return React.createElement(React.Fragment, { key: index },
            "\u00A0",
            partEl);
    })));
};
exports.ExpressionPreview = ExpressionPreview;
